import React__default from 'react';
import PGALogo from './assets/pga-logo.svg.js';

var PgaLogo = (function (_ref) {
  var _ref$src = _ref.src,
    src = _ref$src === void 0 ? PGALogo : _ref$src;
  return /*#__PURE__*/React__default.createElement("img", {
    src: src,
    alt: "PGA Logo"
  });
});

export { PgaLogo as default };
